export default __webpack_public_path__ + "static/media/check-example.f854b231.jpg";